import { apiGet } from '../api'

export const get_categories = () => {
  return apiGet({
    endpoint: 'events/all_categories'
  })
}
